import Grid2 from '@mui/material/Unstable_Grid2';
import HomeIcon from '@mui/icons-material/Home';
import { Autocomplete } from 'mui-rff';
import { useTranslation } from 'react-i18next';
import { type IntegrationParamOption } from 'src/shared/api/integrations/common';
import Select from 'src/shared/components/Form/Select';
import { Step } from '../../components/Step';
import { COUNTRY_OPTIONS, mapParamOptionsToSelect } from '../utils';

type Step2Props = {
  companies: IntegrationParamOption[];
};

export const Step2 = ({ companies }: Step2Props) => {
  const { t } = useTranslation('settings');
  const mappedData = mapParamOptionsToSelect(companies);

  return (
    <Step
      title={`${t('integrations.step')} 2`}
      subtitle={t('integrations.bizneo.select the company you want to synchronize')}
      Icon={HomeIcon}
    >
      <>
        <Grid2 xs={12} sx={{ marginBottom: 1 }}>
          <Select
            sx={{ maxWidth: '300px' }}
            data={COUNTRY_OPTIONS}
            label={t('integrations.bizneo.country')}
            name="country"
          />
        </Grid2>
        <Grid2 xs={12}>
          <Autocomplete
            name="companyId"
            label={t('integrations.bizneo.company')}
            options={mappedData}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            getOptionValue={option => option.value}
            textFieldProps={{
              sx: { maxWidth: '300px' }
            }}
          />
        </Grid2>
      </>
    </Step>
  );
};
